<template>
    <div>
      <div class="d-flex align-items-center min-vh-100 container" >
        <div class="row justify-content-center" style="width: 100%;">
          <flash-message transitionIn="animated swing"></flash-message>
          <div class="col-md-8">
            <div class="card-group">
              <b-card class="p-4">
                <b-card-body>
                  <login-form></login-form>
                </b-card-body>
              </b-card>
              <div class="card text-center py-5 d-md-down-none bg-primary text-white" style="width: 44%;">
                <welcome-card/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

    import LoginForm from "../components/users/LoginForm";
    import WelcomeCard from "../components/WelcomeCard";
    export default {
        name: 'login',
        components: {
          WelcomeCard,
          LoginForm
        },
    }
</script>

<style>
  .img-avatar {
    border-radius: inherit;
  }
</style>
